"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=ITypeHandler.js.map